import { GlButton, GlLoadingIcon } from '@gitlab/ui';
export default {
    name: 'WorkItemChildrenLoadMore',
    components: {
        GlButton,
        GlLoadingIcon
    },
    props: {
        fetchNextPageInProgress: {
            type: Boolean,
            required: true
        }
    },
    emits: [
        'fetch-next-page'
    ]
};
